<template>
    <span class="follow-block">
        <a v-on:click='sendFollow'
           v-bind:class="{'btn-default-ul-active follow-button': followed}"
           v-bind:disabled="loading"
           v-on:mouseover="writeFollowText"
           v-on:mouseleave="writeUnFollowText"
           class='btn btn-default-ul mr-10'>
                <i class="fa fa-check" v-show="followed" v-if="!loading"></i>
                <i v-if='loading' class='fa fa-spinner fa-spin'></i>
                <span v-html='currentFollowText'></span>
        </a>
    </span>
</template>

<script>
    export default {
        props: [
            'followed',
            'follow_text', 'un_follow_text', 'un_follow_hover_text',
            'url', 'organisation_id'
        ],
        data: function () {
            return {
                loading: false,
                currentFollowText: this.followed ? this.un_follow_text : this.follow_text
            }
        },
        methods: {
            sendFollow: function () {
                let thisVm = this;
                if (authorized) {
                    this.loading = true;
                    axios.post(this.url, {
                        organisationId: this.organisation_id
                    })
                    .then(function (response) {
                        if (response.data === false) {
                            thisVm.followed          = false;
                            thisVm.currentFollowText = thisVm.follow_text;
                        } else {
                            thisVm.followed          = true;
                            thisVm.currentFollowText = thisVm.un_follow_text;
                        }
                        thisVm.loading = false;
                    })
                    .catch(function (error) {
                        thisVm.loading           = false;
                        thisVm.followed          = false;
                        thisVm.currentFollowText = thisVm.follow_text;
                    })
                } else {
                    document.getElementById('buttonOpenLoginModal').click();
                }
            },
            writeFollowText: function () {
                if (this.followed === true) {
                    this.currentFollowText = this.un_follow_hover_text;
                }
            },
            writeUnFollowText: function () {
                this.currentFollowText = this.followed ? this.un_follow_text : this.follow_text;
            }
        }
    }
</script>
